/**
 * Utility functions for extracting and formatting VAT details
 * from order objects (Inclusive / Exclusive VAT).
 */

export const getOrderVatDetails = (order) => {
  if (!order) {
    return {
      hasVat: false,
      totalVat: 0,
      vatType: null, // "inclusive" | "exclusive" | null
      vatTypeLabel: "", // "(Inclusive)" | "(Exclusive)" | ""
      shortLabel: "", // "(Inc)" | "(Exc)" | ""
      badgeText: "", // "Inclusive" | "Exclusive" | ""
      formattedLabel: "Total Vat",
    };
  }

  const rawTotalVat = order?.total_vat ?? order?.vat?.total_vat ?? order?.vat_amount ?? 0;
  const totalVat = Number(rawTotalVat || 0);

  const rawType =
    order?.vat_type ||
    order?.vat?.type ||
    (typeof order?.vat === "string" ? order?.vat : null) ||
    order?.vat_settings?.type ||
    order?.vat_type_label ||
    null;

  let vatType = null;
  let vatTypeLabel = "";
  let shortLabel = "";
  let badgeText = "";

  if (rawType && typeof rawType === "string") {
    const lower = rawType.toLowerCase().trim();
    if (
      lower.includes("inclusive") ||
      lower === "inc" ||
      lower === "included" ||
      lower === "include"
    ) {
      vatType = "inclusive";
      vatTypeLabel = "(Inclusive)";
      shortLabel = "(Inc)";
      badgeText = "Inclusive";
    } else if (
      lower.includes("exclusive") ||
      lower === "exc" ||
      lower === "excluded" ||
      lower === "exclude"
    ) {
      vatType = "exclusive";
      vatTypeLabel = "(Exclusive)";
      shortLabel = "(Exc)";
      badgeText = "Exclusive";
    } else if (
      lower !== "no vat" &&
      lower !== "none" &&
      lower !== "false" &&
      lower !== "null" &&
      lower !== "0"
    ) {
      vatType = lower;
      const capitalized = lower.charAt(0).toUpperCase() + lower.slice(1);
      vatTypeLabel = `(${capitalized})`;
      shortLabel = `(${capitalized})`;
      badgeText = capitalized;
    }
  }

  return {
    hasVat: totalVat > 0 || vatType !== null,
    totalVat,
    vatType,
    vatTypeLabel,
    shortLabel,
    badgeText,
    formattedLabel: vatTypeLabel ? `Total Vat ${vatTypeLabel}` : "Total Vat",
  };
};

export default getOrderVatDetails;
